import {Component} from '@angular/core';
import {BaseAppointmentComponent} from "../base-appointment.component";
import {MatIconModule} from "@angular/material/icon";
import {MatRippleModule} from "@angular/material/core";
import {PreventDoubleClickDirective} from "../../../lib/prevent-double-click.directive";
import {Router, RouterLink} from "@angular/router";
import {TemplateInfo} from "@allaihealth/util";
import {MatAnchor} from "@angular/material/button";
import {TemplatesService} from "../../../services/templates.service";
import {MatListModule} from "@angular/material/list";
import {FormsModule} from "@angular/forms";
import {BottomButtonsComponent} from "../../../components/bottom-buttons/bottom-buttons.component";
import {UploadService} from "../../../services/upload.service";

/** Show the available note templates */
@Component({
	selector: 'app-template',
	imports: [
		MatIconModule,
		MatRippleModule,
		PreventDoubleClickDirective,
		RouterLink,
		MatAnchor,
		MatListModule,
		FormsModule,
		BottomButtonsComponent
	],
	templateUrl: './template.component.html',
	styleUrl: './template.component.scss'
})
export class TemplateComponent extends BaseAppointmentComponent {
	/** The templates to show */
	templates:TemplateInfo[];

	/** The selected template from the template list (it's an array because material could in theory select multiple)*/
	selectedTemplate:TemplateInfo[];

	constructor(private templatesService:TemplatesService,
	            private uploadService:UploadService,
	            private router:Router) {
		super();
	}

	override onNewAppointmentData() {
		this.selectedTemplate = null;
		this.templates = this.templatesService.templates;
	}

	/** Send the selected template to the backend and end the recording on the server */
	async applyTemplate() {
		if(this.selectedTemplate) {
			//end the recording
			this.uploadService.endRecording(this.appointment.id, this.selectedTemplate[0].id);

			this.router.navigate(["/appointments", this.recording.appointmentId, "pre-visit"]).then();
		}
	}
}

